module.exports = __webpack_public_path__ + "static/img/li_2.642b846.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_2.jpeg
// module id = +oE/
// module chunks = 6